<template>
  <div class="loginIndex">
    <HeadBar title="个人中心" />
    <div class="userBox">
      <div class="headInfo">
        <p class="topBox">
          <img src="http://ccfmty.com/marathon/%E9%A9%AC%E6%8B%89%E6%9D%BE/013bd670af274692a7e8cfd0d564799a.png"
            width="99" class="myPic" />
        </p>
        <p class="userMobile">{{ FMTY_USERDATA }}</p>
      </div>
      <div class="itemList">
        <van-cell-group>
          <van-cell is-link title="我的赛事" icon="star-o" url="myGame"></van-cell>
          <van-cell is-link title="我的资料" icon="newspaper-o" url="myInfo?disabledEdit=1"></van-cell>
          <van-cell is-link title="我的证书" icon="photo-o" url="myCertificate"></van-cell>
        </van-cell-group>
      </div>
      <div class="loginOutBox">
        <van-button round block type="info" @click="loginOut" class="font-24">退出登录</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import { fetchHttp, delAllCookie } from "@/util/fn.js";
  import { Button, Cell, CellGroup } from "vant";
  export default {
    name: "loginIndex",
    components: {
      HeadBar,
      [Button.name]: Button,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
    },
    data() {
      return {
        postMobile: "",
        postCaptcha: "",
        FMTY_USERDATA: "",
        countdownText: "",
        activeNames: ["1"],
        userData: "您好，请登录",
      };
    },
    computed: {},
    mounted() {

      let FMTY_USERDATA = Cookies.get("FMTY_USERDATA");
      if (FMTY_USERDATA) {
        this.FMTY_USERDATA = FMTY_USERDATA;
      } else {
        delAllCookie();
        setTimeout(() => {
          window.location.href =
            "login?redirect_url=" + encodeURIComponent(window.location.href);
        }, 1000);
      }
    },
    methods: {
      //退出
      loginOut() {
        delAllCookie();

        window.fetch('http://ccfmty.com/marathon/loginOut')
        setTimeout(() => {
          window.location.href = "login";
        }, 500)

      },
    },
  };
</script>
<style scope lang="less">
  .loginBox {
    background-color: #ffffff;
    text-align: center;
    height: calc(100vh - 50px);
  }

  .van-cell--clickable {
    line-height: 30px;
  }

  .userMobile {
    margin-top: 50px;
  }

  .topBox {
    position: relative;
    width: 100px;
    height: 100px;
    left: 50%;
    margin-left: -50px;
  }

  .userName {
    background: rgba(0, 0, 0, 0.5);
    width: 100px;
    display: inline-block;
    position: absolute;
    bottom: -30px;
    left: 0;
  }

  .myPic {
    min-height: 99px;
    border-radius: 100em;
    overflow: hidden;
    margin-top: 40px;
    border: 1px solid #fff;
    overflow: hidden;
    background: #fff;
    padding: 10px;
  }

  .headInfo {
    width: 100vw;
    height: 250px;
    background: linear-gradient(157deg, #5b6f95 0, #35425f 100%);
    text-align: center;
    color: #fff;
  }

  .itemList {
    width: 100%;
  }

  .loginOutBox {
    width: 90%;
    margin: 100px 5% 0px 5%;
  }

  .loginIndex {
    width: 100vw;
    height: calc(100vh - 50px);
    background-color: #f8f8f8;
    padding-bottom: 50px;
    margin-top: -16px;
  }

  .logoImg {
    margin: 50px 0;
  }

  .loginForm .van-cell {
    font-size: 16px;
  }

  .font-24 {
    font-size: 20px;
    margin-top: 50px;
  }
</style>